import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor/BlockEditorContext";
import { useCurrentCommunityMember } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useProfileLinkProps } from "@circle-react/hooks/profile/useProfileLinkProps";

import { ProfileHoverCard } from "@/react/components/Profile/HoverCard";

import type { Mention } from "./types";

const MENTION_TYPES = {
  COMMUNITY_MEMBER: "CommunityMember",
  GROUP_MENTION: ["GroupMention", "group_mention"],
};

interface MentionWithProfileLinkProps {
  isChat?: boolean;
  mention: Mention;
}

export const MentionWithProfileLink = ({
  isChat: isChatProp,
  mention,
}: MentionWithProfileLinkProps) => {
  const currentCommunityMember = useCurrentCommunityMember();
  const tiptapEditorContext = useTipTapEditorContext();
  const tiptapBlockEditorContext = useBlockEditorContext();
  const { type } = tiptapEditorContext || tiptapBlockEditorContext || {};

  const profileLinkProps = useProfileLinkProps({
    public_uid: mention.public_uid,
  });

  const isChat = isChatProp ?? type === "chat";
  const isCommunityMember = mention.type === MENTION_TYPES.COMMUNITY_MEMBER;
  const isGroupMention = MENTION_TYPES.GROUP_MENTION.some(
    item => item === mention.type,
  );
  const isCurrentCommunityMemberMentioned =
    isGroupMention ||
    (isCommunityMember && mention.id === currentCommunityMember?.id);

  const chatClassName = classNames(
    "mx-0.5 rounded-sm px-0.5 py-[1px] font-normal",
    isGroupMention ? "text-[#42464D]" : "text-circle cursor-pointer",
    isCurrentCommunityMemberMentioned ? "bg-amber-100" : "bg-indigo-100",
  );
  const blockClassName = "text-link cursor-pointer font-medium";
  const className = isChat ? chatClassName : blockClassName;

  return (
    <ProfileHoverCard
      communityMemberId={mention.id}
      name={mention.name}
      publicUid={mention.public_uid}
      headline={mention.headline}
      avatarURL={mention.avatar_url}
      side="top"
      sideOffset={10}
      disabled={isGroupMention}
    >
      <span
        contentEditable={false}
        className={className}
        {...(isGroupMention ? {} : profileLinkProps)}
      >
        {isChat ? "@" : ""}
        {mention.name}
      </span>
    </ProfileHoverCard>
  );
};
